import { render, staticRenderFns } from "./GameButtons.vue?vue&type=template&id=118b4c78&"
import script from "./GameButtons.vue?vue&type=script&lang=js&"
export * from "./GameButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports